// Enhanced Variant Selection Functionality
document.addEventListener('DOMContentLoaded', function() {
    const colorSwatchBtns = document.querySelectorAll('.color-swatch-btn');
    const optionSelects = document.querySelectorAll('.option-select');
    const addBtn = document.querySelector('.add-to-basket-btn');
    const productPrice = document.querySelector('.product-price');
    const variantPriceDisplay = document.getElementById('variant-price-display');
    const variantAvailabilityDisplay = document.getElementById('variant-availability-display');
    const stockInfo = document.getElementById('stock-info');

    // Store selected options
    let selectedOptions = {};
    let currentVariant = null;

    // Initialize with first available variant
    function initializeVariant() {
        if (!window.productVariants || window.productVariants.length === 0) return;
        
        // Get the first available variant, or fallback to first variant
        const firstAvailableVariant = window.productVariants.find(v => v.available === true) || window.productVariants[0];
        
        if (firstAvailableVariant) {
            // Set selected options based on the variant
            for (let i = 0; i < firstAvailableVariant.options.length; i++) {
                selectedOptions[i] = firstAvailableVariant.options[i];
            }
            
            // Update the variant display
            updateVariantDisplay(firstAvailableVariant);
            
            // Update the UI to show the selected options
            updateOptionSelectors();
        }
    }

    // Check for variant parameter in URL and preselect it
    function initializeFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        
        if (variantId && window.productVariants) {
            // Find the variant in the product variants
            const targetVariant = window.productVariants.find(v => v.id == variantId);
            
            // SECURITY FIX: Only allow available variants to be selected via URL
            if (targetVariant && targetVariant.available === true) {
                // Set the selected options based on the variant
                for (let i = 0; i < targetVariant.options.length; i++) {
                    selectedOptions[i] = targetVariant.options[i];
                }
                
                // Update the variant display
                updateVariantDisplay(targetVariant);
                
                // Update the UI to show the selected options
                updateOptionSelectors();
                
                return true;
            }
        }
        return false;
    }

    // Update option selectors to show selected state
    function updateOptionSelectors() {
        // Update color swatches
        colorSwatchBtns.forEach(btn => {
            const optionIndex = btn.getAttribute('data-option-index');
            const optionValue = btn.getAttribute('data-option-value');
            
            if (selectedOptions[optionIndex] === optionValue) {
                btn.classList.add('selected');
            } else {
                btn.classList.remove('selected');
            }
        });
        
        // Update dropdown selects
        optionSelects.forEach(select => {
            const optionIndex = select.getAttribute('data-option-index');
            if (selectedOptions[optionIndex]) {
                select.value = selectedOptions[optionIndex];
            }
        });
    }

    // Find matching variant based on selected options
    function findMatchingVariant() {
        if (!window.productVariants) return null;
        
        for (let variant of window.productVariants) {
            let match = true;
            
            for (let optionIndex in selectedOptions) {
                if (variant.options[optionIndex] !== selectedOptions[optionIndex]) {
                    match = false;
                    break;
                }
            }
            
            if (match) {
                return variant;
            }
        }
        
        return null;
    }

    // Helper function to format price (matches Shopify money filter format)
    function formatMoney(cents) {
        // Use Shopify's formatMoney if available, otherwise use Intl.NumberFormat
        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(cents);
        }
        // Fallback to Intl.NumberFormat for GBP
        return new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP'
        }).format(cents / 100);
    }

    // Helper function to format price with sale price display
    function formatPriceWithSale(price, compareAtPrice) {
        const formattedPrice = formatMoney(price);
        
        if (compareAtPrice && compareAtPrice > price) {
            const formattedComparePrice = formatMoney(compareAtPrice);
            
            return `
                <span class="current-price">${formattedPrice}</span>
                <span class="original-price">
                    <span class="was-text">WAS</span> 
                    <span class="price-text">${formattedComparePrice}</span>
                </span>
            `;
        } else {
            return `<span class="price-normal">${formattedPrice}</span>`;
        }
    }

    // Update variant display
    function updateVariantDisplay(variant) {
        if (!variant) return;
        
        currentVariant = variant.id;
        
        // Update add to cart button
        if (addBtn) {
            addBtn.setAttribute('data-variant-id', currentVariant);
        }
        
        // Update price display
        if (variantPriceDisplay) {
            variantPriceDisplay.innerHTML = formatPriceWithSale(variant.price, variant.compare_at_price);
        }
        
        // Update main product price
        if (productPrice) {
            productPrice.innerHTML = formatPriceWithSale(variant.price, variant.compare_at_price);
        }
        
        // Update main image to variant featured image when present
        if (variant.featured_image && variant.featured_image.src) {
            const mainImageEl = document.querySelector('.main-product-image');
            if (mainImageEl) {
                mainImageEl.src = variant.featured_image.src;
            }
            if (variant.featured_image.id) {
                document.querySelectorAll('.thumbnail-image, .mobile-thumbnail-image').forEach(img => {
                    const isMatch = img.getAttribute('data-image-id') == String(variant.featured_image.id);
                    img.classList.toggle('selected', isMatch);
                });
            }
        }
        
        // Update availability display
        if (variantAvailabilityDisplay) {
            const isAvailable = variant.available === true;
            if (isAvailable) {
                variantAvailabilityDisplay.innerHTML = '<span class="in-stock">In Stock</span>';
            } else {
                variantAvailabilityDisplay.innerHTML = '<span class="out-of-stock">Out of Stock</span>';
            }
        }
        
        // Update add to cart button state
        if (addBtn) {
            const isAvailable = variant.available === true;
            if (isAvailable) {
                addBtn.disabled = false;
                addBtn.textContent = 'ADD TO BASKET';
            } else {
                addBtn.disabled = true;
                addBtn.textContent = 'OUT OF STOCK';
            }
        }
        
        // Update stock info display - only show for in-stock variants
        if (stockInfo) {
            const isAvailable = variant.available === true;
            if (isAvailable) {
                // Show stock info for in-stock variants
                stockInfo.style.display = 'block';
        } else {
                // Hide stock info for out-of-stock variants
                stockInfo.style.display = 'none';
            }
        }
    }

    // Handle color swatch selection
    colorSwatchBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            if (this.classList.contains('disabled')) return;
            
            const optionIndex = this.getAttribute('data-option-index');
            const optionValue = this.getAttribute('data-option-value');
            
            // Remove selected class from all swatches in this option group
            document.querySelectorAll(`[data-option-index="${optionIndex}"]`).forEach(swatch => {
                swatch.classList.remove('selected');
            });
            
            // Add selected class to clicked swatch
            this.classList.add('selected');
            
            // Update selected options
            selectedOptions[optionIndex] = optionValue;
            
            // Find and update matching variant
            const matchingVariant = findMatchingVariant();
            updateVariantDisplay(matchingVariant);
        });
    });

    // Handle dropdown selection
    optionSelects.forEach(select => {
        select.addEventListener('change', function() {
            const optionIndex = this.getAttribute('data-option-index');
            const optionValue = this.value;
            
            if (optionValue) {
                selectedOptions[optionIndex] = optionValue;
            } else {
                delete selectedOptions[optionIndex];
            }
            
            // Find and update matching variant
            const matchingVariant = findMatchingVariant();
            updateVariantDisplay(matchingVariant);
        });
    });

    // Initialize - first try URL parameter, then fallback to default
    if (!initializeFromURL()) {
        initializeVariant();
    }
});
